import errorManager from '@/rollbar.js';

const validationPrompt = (inputId, submitId, lengthRequired) => {
  const otpInput = document.getElementById(inputId);
  const submitBtn = document.getElementById(submitId);

  otpInput.addEventListener('input', function () {
    const value = otpInput.value.trim();
    const regex = new RegExp(`^\\d{${lengthRequired}}$`);

    const isValid = regex.test(value);

    submitBtn.disabled = !isValid;
  });
};

const init = (inputSelector, submitSelector, inputLength) => {
  try {
    validationPrompt(inputSelector, submitSelector, inputLength);
  } catch (e) {
    errorManager(e);
  }
};

window.PromptTwoFactorValidation = {
  init,
};
